// extracted by mini-css-extract-plugin
export default {"buttons":"ScaleSelector_buttons__ZnlDU","radioGroup":"ScaleSelector_radioGroup__Q2lSX"};